import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { UserIdMenu } from '../../components/common/UserIdMenu';
import type { ParticipantIdentity } from './participantIdentity';

export function ParticipantAvatar({
  participant,
  compact = false,
}: {
  participant: ParticipantIdentity;
  compact?: boolean;
}) {
  return (
    <UserIdMenu
      userId={
        participant.kind === 'user' ? participant.id : participant.ownerUserId
      }
      owner={participant.kind === 'agent'}
    >
      <span
        className={`inspector-participant-avatar ${compact ? 'is-compact' : ''}`}
        role="img"
        aria-label={`${participant.name}的头像`}
        title={
          participant.id
            ? `${participant.name} · ${participant.id}`
            : participant.name
        }
      >
        <Avatar
          aria-hidden="true"
          size={compact ? 20 : 32}
          src={participant.avatarUrl}
          className={
            participant.kind === 'user' ? 'is-user-avatar' : 'is-agent-avatar'
          }
        >
          {participant.kind === 'agent' ? (
            <RobotOutlined />
          ) : participant.id ? (
            Array.from(participant.name)[0]
          ) : (
            <UserOutlined />
          )}
        </Avatar>
        {!compact && participant.kind === 'agent' && participant.ownerName && (
          <Avatar
            aria-hidden="true"
            className="inspector-owner-avatar"
            size={14}
            src={participant.ownerAvatarUrl}
          >
            {Array.from(participant.ownerName)[0]}
          </Avatar>
        )}
      </span>
    </UserIdMenu>
  );
}
